import { jsx, jsxs } from "react/jsx-runtime";
import { CommandItem } from "../../_shadcn-native-components/command.js";
import { cn } from "../../utils.js";
import { sanitizeText } from "../utils/sanitize-text.js";
const DropdownTextItem = ({ text, value, selected, className, onSelect, description, multiline, ...itemProps })=>/*#__PURE__*/ jsx(CommandItem, {
        className: cn(multiline && 'tw-items-start tw-overflow-hidden', className),
        selected: selected,
        value: value,
        onSelect: ()=>onSelect(value),
        ...itemProps,
        children: description ? /*#__PURE__*/ jsxs("div", {
            className: "tw-flex tw-flex-col tw-w-full",
            children: [
                /*#__PURE__*/ jsx("h5", {
                    className: cn('tw-font-subtitle5 tw-w-full', multiline ? 'tw-break-words tw-min-w-0' : 'tw-truncate'),
                    children: sanitizeText(text)
                }),
                /*#__PURE__*/ jsx("p", {
                    className: cn('tw-font-body5 tw-text-neutral-light-700 tw-w-full', multiline ? 'tw-break-words tw-min-w-0' : 'tw-truncate'),
                    children: sanitizeText(description)
                })
            ]
        }) : /*#__PURE__*/ jsx("p", {
            className: multiline ? 'tw-break-words tw-min-w-0' : 'tw-truncate',
            children: sanitizeText(text)
        })
    }, value);
export { DropdownTextItem };
